var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useUpdate } from 'src/shared/hooks/useLifecycle';
import styles from './Time.module.scss';
import { valueExist } from 'src/shared/helpers/objHelpers';
import { Select } from 'src/ui/components/Input/Select/Select';
import { IDENTIFIER_DATETIME_INPUT_CALENDAR_TIME } from 'src/ui/components/Input/DateTimeInput/constants';
var hoursList = Array.from({ length: 24 }, function (item, index) { return index.toString(); });
var minutesListBy5 = Array.from({ length: 12 }, function (item, index) { return (index * 5).toString(); });
export var Time = function (props) {
    var hoursProps = props.hours, minutesProps = props.minutes, onTimeChange = props.onTimeChange;
    var _a = useState(valueExist(hoursProps) ? hoursProps : null), hours = _a[0], setHours = _a[1];
    var _b = useState(valueExist(minutesProps) ? minutesProps : null), minutes = _b[0], setMinutes = _b[1];
    useUpdate(function () {
        setHours(hoursProps);
        setMinutes(minutesProps);
    }, [hoursProps, minutesProps]);
    useUpdate(function () {
        onTimeChange({ hours: hours, minutes: minutes });
    }, [hours, minutes]);
    var checkValue = function (value, min, max) {
        return value <= max && value >= min ? value : null;
    };
    var handleHoursChange = function (value) {
        var valueNumber = Number.parseInt(value, 10);
        if (!Number.isNaN(valueNumber)) {
            var value_1 = checkValue(valueNumber, 0, 23);
            if (valueExist(value_1)) {
                setHours(value_1);
            }
        }
    };
    var handleMinutesChange = function (value) {
        var valueNumber = Number.parseInt(value, 10);
        if (!Number.isNaN(valueNumber)) {
            var value_2 = checkValue(valueNumber, 0, 59);
            if (valueExist(value_2)) {
                setMinutes(value_2);
            }
        }
    };
    var hoursParsed = (hours === null || hours === void 0 ? void 0 : hours.toString()) || '0';
    var minutesParsed = (minutes === null || minutes === void 0 ? void 0 : minutes.toString()) || '0';
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_CALENDAR_TIME, className: styles.timeValuesWrapper }, { children: [_jsx(Select, { options: hoursList, multiple: false, value: hoursParsed, onChange: handleHoursChange, className: styles.timeSelect }), _jsx(Select, { options: minutesListBy5, multiple: false, value: minutesParsed, onChange: handleMinutesChange, className: styles.timeSelect })] })));
};
